import { createFileRoute } from '@tanstack/react-router';
import usePersonParams from '@/routes/_staff/person/$id/-hooks/usePersonParams';
import { PublicIdInformationDetail } from '@/routes/_staff/person/$id/_profile/public-id/-components/PublicIdInformationDetail';
import { prefetchPublicIdInformationDetail } from '@/routes/_staff/person/$id/_profile/public-id/-query';
export const Route = createFileRoute('/_staff/person/alumni/$id/_profile/public-id/')({
  component: PublicIdInformation,
  loader: ({
    params
  }) => prefetchPublicIdInformationDetail(params.id)
});
function PublicIdInformation() {
  const {
    id
  } = usePersonParams();
  return <PublicIdInformationDetail personId={id} linkTo="/person/alumni/$id/public-id" />;
}